import { createContext, useContext } from "react";
import type { MinorGuardian } from "creso-core/types";

export type { GuardianRelationship, MinorGuardian } from "creso-core/types";

type MinorOnboardingContextValue = {
  guardian: MinorGuardian | null;
};

// Shares the minor's guardian (from useMinorGuardian) between the Minor
// onboarding steps. The dialog reads it so it can add the Guardian profile step.
export const MinorOnboardingContext =
  createContext<MinorOnboardingContextValue>({ guardian: null });

export function useMinorOnboarding() {
  return useContext(MinorOnboardingContext);
}

/** A guardian who isn't your client yet needs a Guardian profile step */
export const isNewGuardian = (guardian: MinorGuardian | null) =>
  !!guardian && !guardian.readOnly;
